import { cn } from '@/utils/style';
import Spark from '../../../../public/images/medicine-dictionary/spark.svg';

interface Props {
  simplifiedName?: string;
  indications?: string[];
}

const MedicineGuideIndication = (props: Props) => {
  return (
    <section className={cn('flex flex-col gap-[20px] px-[24px] py-[28px]')}>
      <div className='flex items-center gap-[8px]'>
        <Spark className='shrink-0' />
        <h2 className='typography-ui-19sb shrink-1 select-text text-gray-700'>{props.simplifiedName} 효능/효과</h2>
      </div>
      <div className='flex flex-col gap-[20px]'>
        {props.indications?.map((efficacy, index) => {
          return (
            <div key={`efficacy-${efficacy || index}`} className='flex flex-col gap-[12px]'>
              <ul className='flex flex-col gap-[12px]'>
                <li key={`efficacy-${efficacy}`} className='typography-ui-15r select-text text-gray-700'>
                  {efficacy}
                </li>
              </ul>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default MedicineGuideIndication;
